import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import { mieterstromInvoicingApiWithoutCamelization } from "../../../api/subApis/mieterstromInvoicingApi";
import type { components } from "../../../types/api.types";

export type PendingInvoice = components["schemas"]["PendingInvoice"];

export function usePendingInvoices(projectId: string) {
  return useQuery({
    queryKey:
      mieterstromInvoicingApiWithoutCamelization.pendingInvoices.key(projectId),
    queryFn: () => fetchPendingInvoices(projectId)
  });
}

async function fetchPendingInvoices(projectId: string) {
  const url =
    mieterstromInvoicingApiWithoutCamelization.pendingInvoices.url(projectId);
  const response = await apiWithoutCamelization.get<Array<PendingInvoice>>(url);
  return response.data;
}
